import { Typography } from "antd";
import type { ReactNode } from "react";

type Props = {
  children: ReactNode;
  size?: "sm" | "md";
};

const UppercaseLabel = ({ children, size = "sm" }: Props) => (
  <Typography.Text
    style={{
      fontSize: 11,
      color: "#6b7280",
      textTransform: "uppercase",
      letterSpacing: size === "md" ? "0.06em" : "0.05em",
      fontWeight: 600,
    }}
  >
    {children}
  </Typography.Text>
);

export default UppercaseLabel;
